// // import React from "react";
// // import Chart from "react-apexcharts";

// // const SteplineChart = () => {
// //   const options = {
// //     chart: {
// //       type: "line",
// //       height: 350,
// //       toolbar: {
// //         show: false,
// //       },
// //       zoom: {
// //         enabled: false,
// //       },
// //     },
// //     stroke: {
// //       curve: "stepline",
// //       colors: ["#FF641B"],
// //     },
// //     dataLabels: {
// //       enabled: false,
// //     },
// //     title: {
// //       text: "New vs User Returning",
// //       align: "left",
// //     },
// //     yaxis: {
// //       opposite: true,
// //       labels: {
// //         style: {
// //           colors: "#000",
// //         },
// //       },
// //     },
// //     colors: ["#FF641B"],
// //   };

// //   const series = [
// //     {
// //       data: [34, 44, 54, 21, 12, 43, 33],
// //     },
// //   ];

// //   return (
// //     <div id="chart">
// //       <Chart options={options} series={series} type="line" height={350} />
// //     </div>
// //   );
// // };

// // export default SteplineChart;
// import React from "react";
// import Chart from "react-apexcharts";
// import SkeletonCard from "./SkeletonCard";

// const SteplineChart = ({ isLoading }) => {
//   const rawData = [
//     { date: "2025-04-01", users: 0 },
//     { date: "2025-04-06", users: 1 },
//     { date: "2025-04-07", users: 0 },
//     { date: "2025-04-13", users: 1 },
//     { date: "2025-04-20", users: 0 },
//   ];

//   const series = [
//     {
//       name: "Users",
//       data: rawData.map((item) => ({
//         x: item.date,
//         y: item.users,
//       })),
//     },
//   ];

//   const hasData = series[0]?.data?.length > 0;

//   const options = {
//     chart: {
//       type: "line",
//       height: 350,
//       toolbar: { show: false },
//       zoom: { enabled: false },
//     },
//     stroke: {
//       curve: "stepline",
//       colors: ["#FF641B"],
//     },
//     dataLabels: { enabled: false },
//     title: {
//       text: "New vs Returning Users",
//       align: "left",
//       style: { color: "#000" },
//     },
//     xaxis: {
//       type: "category",
//       labels: {
//         style: { colors: "#000" },
//         rotate: -45,
//         formatter: (value) => {
//           const date = new Date(value);
//           return date.toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "short",
//           }); // e.g., "06 Apr"
//         },
//       },
//       title: {
//         text: "Date",
//         style: { color: "#000" },
//       },
//     },
//     yaxis: {
//       opposite: true,
//       min: 0,
//       max: 1.2,
//       tickAmount: 6,
//       labels: {
//         style: { colors: "#000" },
//       },
//       title: {
//         text: "Users",
//         style: { color: "#000" },
//       },
//     },
//     colors: ["#FF641B"],
//   };

//   return (
//     <div id="chart">
//       {isLoading ? (
//         <div>
//           <SkeletonCard count={10} width={300} />
//         </div>
//       ) : hasData ? (
//         <Chart options={options} series={series} type="line" height={350} />
//       ) : (
//         <div>No data available</div>
//       )}
//     </div>
//   );
// };

// export default SteplineChart;
import React from "react";
import Chart from "react-apexcharts";
import SkeletonCard from "./SkeletonCard";

const SteplineChart = ({ isLoading, data }) => {
const uniqueSortedDates = [...new Set(data.map((item) => item.date))].sort(
  (a, b) => new Date(a) - new Date(b)
);

const formattedData = uniqueSortedDates.reduce(
  (acc, date) => {
    const newUserItem = data.find(
      (d) => d.date === date && d.user_type === "new"
    );
    const returningUserItem = data.find(
      (d) => d.date === date && d.user_type === "returning"
    );

    acc.newUsers.push({
      x: date,
      y: newUserItem ? Number(newUserItem.active_users || 0) : 0,
    });
    acc.returningUsers.push({
      x: date,
      y: returningUserItem ? Number(returningUserItem.active_users || 0) : 0,
    });

    return acc;
  },
  { newUsers: [], returningUsers: [] }
);

  const series = [
    {
      name: "New Users",
      data: formattedData.newUsers,
    },
    {
      name: "Returning Users",
      data: formattedData.returningUsers,
    },
  ];

  const hasData = series.some((s) => s.data.length > 0);

  const options = {
    chart: {
      type: "line",
      height: 400,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "straight",
      width: 3,
    },
    dataLabels: { enabled: false },
    title: {
      text: "New vs Returning Users",
      align: "left",
      style: { color: "#000", fontSize: "16px" },
    },
    xaxis: {
      type: "category",
      categories: uniqueSortedDates, 
      labels: {
        rotate: -30,
        style: { fontSize: "9px", colors: "#000" },
      },
      title: {
        text: "Date",
        style: { color: "#000", fontSize: "12px" },
      },
    },

    yaxis: {
      opposite: true,
      min: 0,
      max:
        Math.max(...data.map((d) => Number(d.active_users || 0))) <= 1
          ? 1.2
          : undefined,
      tickAmount: 4,
      labels: {
        style: { colors: "#000", fontSize: "12px" },
        formatter: (value) =>
          typeof value === "number" ? value.toFixed(1) : "0.0",
      },
      title: {
        text: "Users",
        style: { color: "#000", fontSize: "14px" },
      },
    },
    colors: ["#FF641B", "#28a745"],
    legend: {
      show: true, // Hide legend to reduce side gap
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { height: 300 },
          xaxis: {
            labels: {
              rotate: -45,
              style: { fontSize: "10px" },
            },
          },
        },
      },
    ],
    grid: {
      padding: {
        left: 10,
        right: 10,
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "400px" }}>
      {isLoading ? (
        <SkeletonCard count={10} width={300} />
      ) : hasData ? (
        <Chart options={options} series={series} type="line" height="100%" />
      ) : (
        <div>No data available</div>
      )}
    </div>
  );
};

export default SteplineChart;
